import React from "react";
import { useAuth } from "context/AuthContext";
import { Navigate } from "react-router-dom"; // If you're using react-router
import { CircularProgress } from "@mui/joy";
import { Box } from "@mui/material";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    // Optionally, show a loading spinner while checking auth status
    return (
      <Box style={{ height: "100vh", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress color="success" />
      </Box>
    );
  }

  // If no user is logged in, redirect to the login page
  if (!user) {
    return <Navigate to="/signin" />;
  }

  // Otherwise, render the protected content (profile page, etc.)
  return children;
};

export default ProtectedRoute;
